import { render, staticRenderFns } from "./AskChangeBtn.vue?vue&type=template&id=e018c428&scoped=true"
import script from "./AskChangeBtn.vue?vue&type=script&lang=js"
export * from "./AskChangeBtn.vue?vue&type=script&lang=js"
import style0 from "./AskChangeBtn.vue?vue&type=style&index=0&id=e018c428&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e018c428",
  null
  
)

export default component.exports